/**
 * Provides APIs to set and get runtimeParams which will be used by nebula components
 * @class RuntimeParamsAPI
 * @private
 */
class RuntimeParamsAPI {
  public runtimeParams: { [key: string]: object };
  public runtimeParamsMap: { [key: string]: string };

  constructor() {
    this.runtimeParams = {};
    this.runtimeParamsMap = {};
  }
  /**
   * sets runtimeParams
   * @param runtimeParams
   * @example <caption>PCore.getRuntimeParamsAPI().setRuntimeParams({})</caption>
   * @private
   */

  setRuntimeParams(runtimeParams: { [key: string]: object }) {
    this.runtimeParams = runtimeParams;
  }

  /**
   * returns runtimeParams object
   * @example <caption>PCore.getRuntimeParamsAPI().getRuntimeParams()</caption>
   * @private
   */

  getRuntimeParams() {
    return this.runtimeParams;
  }

  /**
   * This API is used to set a value for the given property at the global level
   * @example <caption>
   * PCore.getRuntimeParamsAPI().setRuntimeParam('context', 'app');
   * </caption>
   * @param key property key
   * @param value property value
   * @private
   */
  setRuntimeParam(key: string, value: string) {
    this.runtimeParamsMap[key] = value;
  }

  /**
   * This API is used to get a specific for the given property at global level
   * @example <caption>
   * PCore.getRuntimeParamsAPI().setRuntimeParam('context', 'app');
   * const runtimeContext = RuntimeParamsAPI.getRuntimeParam('context');
   * </caption>
   * @param key property key
   * @returns property value
   * @private
   */
  getRuntimeParam(key: string) {
    return this.runtimeParamsMap[key];
  }
}

export default new RuntimeParamsAPI();
